import { redirect } from "react-router-dom";
import { store } from "../store";
import { checkSession } from "../store/thunks/authThunks";

// Honestly dont like this implementation but it works for now
// Is it best practice to check the backend for session status on hard refresh ?
export const adminLoader = async () => {
  try {
    const result = await store.dispatch(checkSession()).unwrap();
    if (result.user.role !== "admin") {
      throw redirect("/");
    }
    return null;
  } catch (error) {
    if (error instanceof Response) {
      throw error; // Re-throw redirect responses
    }
    throw redirect("/login");
  }
};